'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Timeline = require('./Timeline');

var _Timeline2 = _interopRequireDefault(_Timeline);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

exports['default'] = _Timeline2['default'];
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ../~/antd/lib/timeline/index.js
// module id = G4zP
// module chunks = 0